// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add all variables here */
:host {
  display: inline-block;
  height: 100%;
}
:host::ng-deep app-price-table .item {
  background-color: #fafafa;
  color: #212529;
}

app-product-compact-rating {
  border-bottom: 1px solid #efefef;
  padding: 2px 0;
}

.product-widget-description {
  background: white;
  padding: 60px 30px 30px;
  display: flex;
  flex-grow: 1;
}
.product-widget-description .product-image {
  height: 250px;
  margin-bottom: 20px;
  position: relative;
}
.product-widget-description .product-image .savings {
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  justify-content: center;
  color: white;
  background: rgba(92, 10, 49, 0.9);
  border-radius: 50%;
  height: 95px;
  width: 95px;
  text-align: center;
  position: absolute;
  top: 40px;
}
.product-widget-description .product-image .savings .price {
  font-size: 1.4375rem;
  font-weight: 600;
}
.product-widget-description .product-info {
  display: flex;
  flex-direction: column;
}
.product-widget-description .product-info h4 {
  font-size: 1.375rem;
  font-family: "PT Serif", serif;
}
.product-widget-description .product-info .hit-description {
  font-size: 0.9rem;
}

:host {
  position: relative;
  color: #212529;
  display: flex;
  flex-direction: column;
  height: 100%;
}
:host app-product-compact-rating {
  color: #212529;
}
:host a:not(.btn) {
  color: #212529;
  text-decoration: none;
  word-break: break-word;
}
:host .ratings {
  margin-top: auto;
}
:host.list {
  flex-direction: row;
}
:host.list.is-discounted {
  padding-top: 60px;
}
:host.list .product-top {
  width: 100%;
}
:host.list .product-top .product-image {
  display: flex;
  flex-basis: 200px;
  justify-content: center;
}
:host.list .product-top .product-info {
  max-height: 280px;
  overflow: hidden;
}
:host.list .product-top .product-info .ratings {
  max-width: 250px;
}
:host.list app-price-table {
  margin-top: 0;
  margin-bottom: auto;
  max-width: 300px;
  width: 100%;
  margin-left: 15px;
}

app-price-table {
  padding: 0 30px 20px;
  background-color: white;
}

.energy-label {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}
.energy-label a {
  text-decoration: underline;
}

.displayRow {
  display: flex;
  flex-wrap: wrap;
}

.displayCol {
  display: flex;
  flex-direction: column;
}

.col4Width {
  max-width: 33.3333333333%;
  flex: 0 0 33.3333333333%;
}

.col8Width {
  max-width: 66.6666666667%;
  flex: 0 0 66.6666666667%;
}

.fullWidth {
  max-width: 100%;
  margin-bottom: 1rem;
}

.fullWidthMarginBottom {
  max-width: 100%;
  text-align-last: center;
  margin-bottom: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/variables.scss","webpack://./src/app/content/layout/components/product/product-widget/product-widget.component.scss"],"names":[],"mappings":"AAAA,2BAAA;ACEA;EACE,qBAAA;EACA,YAAA;AAAF;AAIM;EACE,yBAAA;EACA,cAAA;AAFR;;AAQA;EACE,gCAAA;EACA,cAAA;AALF;;AAQA;EACE,iBAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;AALF;AAOE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AALJ;AAOI;EACE,aAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AALN;AAOM;EACE,oBAAA;EACA,gBAAA;AALR;AAUE;EACE,aAAA;EACA,sBAAA;AARJ;AAUI;EACE,mBAAA;EACA,8BAAA;AARN;AAWI;EACE,iBAAA;AATN;;AAcA;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAXF;AAaE;EACE,cAAA;AAXJ;AAcE;EACE,cAAA;EACA,qBAAA;EACA,sBAAA;AAZJ;AAeE;EACE,gBAAA;AAbJ;AAgBE;EACE,mBAAA;AAdJ;AAgBI;EACE,iBAAA;AAdN;AAiBI;EACE,WAAA;AAfN;AAiBM;EACE,aAAA;EACA,iBAAA;EACA,uBAAA;AAfR;AAkBM;EACE,iBAAA;EACA,gBAAA;AAhBR;AAkBQ;EACE,gBAAA;AAhBV;AAqBI;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;AAnBN;;AAwBA;EACE,oBAAA;EACA,uBAAA;AArBF;;AAwBA;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;AArBF;AAuBE;EACE,0BAAA;AArBJ;;AA0BA;EACE,aAAA;EACA,eAAA;AAvBF;;AA0BA;EACE,aAAA;EACA,sBAAA;AAvBF;;AA0BA;EACE,yBAAA;EACA,wBAAA;AAvBF;;AA0BA;EACE,yBAAA;EACA,wBAAA;AAvBF;;AA0BA;EACE,eAAA;EACA,mBAAA;AAvBF;;AA0BA;EACE,eAAA;EACA,uBAAA;EACA,mBAAA;AAvBF","sourcesContent":["/* Add all variables here */\n\n@import \"bootstrap/scss/functions\";\n@import \"bootstrap/scss/variables\";\n\n$text-orange: #F7941E;\n$wine-red-light: #5c0a31;\n$wine-red-dark: #3d051f;\n$wine-text-color: #37041c;\n$light-grey: #efefef;\n$yellow-cta: #ff9812;\n$gold: #e0b55d;\n$color-cloud-grey: #F9F9F9;\n$color-grey: #d5d5d5;\n$color-almost-black: #212529;\n$stock-green: #60E040;\n\n$supervin-color-bordeaux: #3E0523;\n\n$color-charcoal-black: #000;\n$theme-colors: (\n  \"primary\": $yellow-cta,\n  \"secondary\": $secondary,\n  \"success\": $yellow-cta, //$success,\n  \"info\": $yellow-cta, //$info,\n  \"warning\": $warning,\n  \"danger\": $danger,\n  \"light\": $light,\n  \"dark\": $dark\n);\n\n$container-max-widths: (\n  xl: 1280px\n);\n\n$header-height: 100px;\n\n$border-divider: 1px solid $color-cloud-grey;\n$breadcrumb-height: 30px;\n\n@mixin supervin-box-shadow {\n  box-shadow: 1px 1px 5px 0 rgba(0,0,0,0.4);\n}\n\n@mixin btn-primary {\n\n  border-radius: 0;\n  text-transform: uppercase;\n  padding: 0.7rem 1.3rem;\n  font-size: 0.8rem;\n  background-color: $yellow-cta;\n  border: solid 1px $yellow-cta;\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  line-height: 1.5;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n\n\n\n","@import \"src/variables\";\n\n:host {\n  display: inline-block;\n  height: 100%;\n\n  &::ng-deep {\n    app-price-table {\n      .item {\n        background-color: #fafafa;\n        color: #212529;\n      }\n    }\n  }\n}\n\napp-product-compact-rating {\n  border-bottom: 1px solid $light-grey;\n  padding: 2px 0;\n}\n\n.product-widget-description {\n  background: white;\n  padding: 60px 30px 30px;\n  display: flex;\n  flex-grow: 1;\n\n  .product-image {\n    height: 250px;\n    margin-bottom: 20px;\n    position: relative;\n\n    .savings {\n      display: flex;\n      flex: 1 1 0;\n      flex-direction: column;\n      justify-content: center;\n      color: white;\n      background: rgba($wine-red-light, 0.9);\n      border-radius: 50%;\n      height: 95px;\n      width: 95px;\n      text-align: center;\n      position: absolute;\n      top: 40px;\n\n      .price {\n        font-size: 1.4375rem;\n        font-weight: 600;\n      }\n    }\n  }\n\n  .product-info {\n    display: flex;\n    flex-direction: column;\n\n    h4 {\n      font-size: 1.375rem;\n      font-family: \"PT Serif\", serif;\n    }\n\n    .hit-description {\n      font-size: 0.9rem;\n    }\n  }\n}\n\n:host {\n  position: relative;\n  color: #212529;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n\n  app-product-compact-rating {\n    color: #212529;\n  }\n\n  a:not(.btn) {\n    color: #212529;\n    text-decoration: none;\n    word-break: break-word;\n  }\n\n  .ratings {\n    margin-top: auto;\n  }\n\n  &.list {\n    flex-direction: row;\n\n    &.is-discounted {\n      padding-top: 60px;\n    }\n\n    .product-top {\n      width: 100%;\n\n      .product-image {\n        display: flex;\n        flex-basis: 200px; // overwrite column settings.\n        justify-content: center;\n      }\n\n      .product-info {\n        max-height: 280px;\n        overflow: hidden;\n\n        .ratings {\n          max-width: 250px;\n        }\n      }\n    }\n\n    app-price-table {\n      margin-top: 0;\n      margin-bottom: auto;\n      max-width: 300px;\n      width: 100%;\n      margin-left: 15px;\n    }\n  }\n}\n\napp-price-table {\n  padding: 0 30px 20px;\n  background-color: white;\n}\n\n.energy-label {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  align-items: center;\n\n  a {\n    text-decoration: underline;\n  }\n}\n\n//remember to rewrite this code\n.displayRow {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.displayCol {\n  display: flex;\n  flex-direction: column;\n}\n\n.col4Width {\n  max-width: 33.3333333333%;\n  flex: 0 0 33.3333333333%;\n}\n\n.col8Width {\n  max-width: 66.6666666667%;\n  flex: 0 0 66.6666666667%;\n}\n\n.fullWidth {\n  max-width: 100%;\n  margin-bottom: 1rem;\n}\n\n.fullWidthMarginBottom {\n  max-width: 100%;\n  text-align-last: center;\n  margin-bottom: 1rem;\n}\n\n//remember to rewrite this code\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
